// Race sources: where frames come from. Live socket or a recorded race; both produce the same frames.
export type { RaceSource } from '../../race/types';

export type SourceStatus = 'connecting' | 'open' | 'reconnecting' | 'failed';

/** Timers and time, injectable so sources can be tested without real waiting. */
export interface Scheduler {
  now(): number;
  setTimeout(fn: () => void, ms: number): unknown;
  clearTimeout(handle: unknown): void;
}

export const realScheduler: Scheduler = {
  now: () => (typeof performance !== 'undefined' ? performance.now() : Date.now()),
  setTimeout: (fn, ms) => setTimeout(fn, ms),
  clearTimeout: (h) => clearTimeout(h as ReturnType<typeof setTimeout>),
};

export const LIVE_LABEL = 'LIVE · kissaderby.fi';
export const REPLAY_LABEL = 'Recorded kissaderby.fi race — live derby unavailable';
